// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { BuildCreditNoteResponseFragment } from '../../fragments/generated/build-credit-note.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BuildCreditNoteQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type BuildCreditNoteQueryResult = { __typename?: 'Query', buildCreditNote: { __typename?: 'BuildCreditNoteResponseDTO', invoiceId: number, cancellableDocumentType: Types.CancellableDocumentTypeEnumDto, editMode: Types.EditModeEnumDto, originalInvoiceDate: LocalDate, originalInvoiceType: Types.InvoiceDocumentTypeDto, vats: Array<number>, cityTax: number | null, paymentId: number | null, paymentAmount: number | null, payment2Id: number | null, payment2Amount: number | null, notes: string | null, elements: Array<{ __typename?: 'ElementDTO', amount: number, description: string, id: string, quantity: number | null, vat: number | null }>, linkedDeposits: Array<{ __typename?: 'InvoiceToDepositDTO', amount: number, depositId: number, invoiceId: number, deposit: { __typename?: 'DepositDTO', amount: number, block: string | null, date: LocalDate, depositInvoiceId: number | null, depositUseId: number | null, holderId: number | null, holderType: Types.InvoiceHolderTypeDto | null, id: number, ownerCorporateDataId: number | null, ownerId: number, paymentId: number | null, reservationId: number | null, username: string | null } }> } };

export const BuildCreditNoteGql = gql`
    query BuildCreditNote($invoiceId: Int!) {
  buildCreditNote(invoiceId: $invoiceId) {
    ...BuildCreditNoteResponse
  }
}
    ${BuildCreditNoteResponseFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BuildCreditNoteInjectable extends Apollo.Query<BuildCreditNoteQueryResult, BuildCreditNoteQueryVariables> {
    override document = BuildCreditNoteGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */